let BASE_URL = process.env.NODE_ENV;
// if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
//   BASE_URL = "http://localhost:4000/";
// }

export { BASE_URL };
